const SparkleIcon = () => {
  return (
    <svg viewBox="6 2 12 12" fill="currentColor" aria-hidden="true">
      <path
        d="M12 3.5C12.4 5.6 14.4 7.6 16.5 8C14.4 8.4 12.4 10.4 12 12.5C11.6 10.4 9.6 8.4 7.5 8C9.6 7.6 11.6 5.6 12 3.5Z"
        stroke="currentColor"
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SparkleIcon
